module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKgAAAAEAQMAAAAgW+ZiAAAAA1BMVEXnIB5kXOI+AAAAC0lEQVQI12OgEQAAAFgAAXCFyT4AAAAASUVORK5CYII="